module.exports = __webpack_public_path__ + "static/media/logo.4f3ee87f.png";